<template>
    <div class="main" ref="main">
        <span v-show="isShowArrow" class="span-arrow-left" :class=" {'no-allowed': !isAllowedLeft} " @click="isAllowedLeft && leftArrowBtn()">
            <i class="el-icon-arrow-left"></i>
        </span>
        <div v-if="isShowArea" class="show_area" :style="{ width: show_area_width + 'px' }">
            <div class="area" :style="{ left: leftLength + 'px' }" ref="area" >
                <el-tag 
                    v-for="(tag, index) in datas" 
                    :title="tag.name" 
                    :key="index" 
                    :closable="isClosable"
                    @close="handleClose(tag)"
                >{{tag.name}}</el-tag>
            </div>
        </div>
        <span v-show="isShowArrow" class="span-arrow-right" :class=" {'no-allowed': !isAllowedRight} " @click="isAllowedRight && rightArrowBtn()">
            <i class="el-icon-arrow-right"></i>
        </span>
    </div>
</template>
<script>
export default {
    name: 'v-labels',
    props: {
        datas: {
            type: Array,
            default: ()=>{
                return []
            },
        },
        isClosable: {
            type: Boolean,
            default: false
        },
        comp_name: {
            tyep: String,
            default: ''
        }
    },
    data () {
        return {
            show_area_width: 0,
            isShowArrow: false,
            isAllowedLeft: true,
            isAllowedRight: true,
            step: 0,
            leftLength: 0,
            isShowArea: false,
        }
    },
    mounted () {
        this.show_area_width = this.$refs.main.clientWidth - 75;
    },
    watch: {
        datas: {
            handler(val) {
                if (val.length > 0) {
                    this.getAreaWidth()
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        getAreaWidth() {
            this.isShowArea = false;
            this.$nextTick(()=>{
                this.isShowArea = true;
                this.$nextTick(()=>{
                    let w = this.$refs.area.clientWidth;
                    if ( w > this.show_area_width ) {
                        this.isShowArrow = true
                    } else {
                        this.isShowArrow = false
                    }
                })  
            })
        },
        leftArrowBtn() {
            let L = this.$refs.area.offsetLeft;
            if ( L >= 0 ) {
                this.isAllowedLeft = false
            } else {
                this.step -= 1;
                this.leftLength = -50 * this.step;
                if ( ( -this.leftLength + this.show_area_width) < this.$refs.area.clientWidth ) {
                    this.isAllowedRight = true;
                }
            }
        },
        rightArrowBtn() {
            this.step += 1;
            this.leftLength = -50 * this.step;
            if ( this.leftLength < 0 ) {
                this.isAllowedLeft = true
            }
            if ( ( -this.leftLength + this.show_area_width) > this.$refs.area.clientWidth ) {
                this.isAllowedRight = false;
            }
        },
        handleClose(tag) {
            if ( this.comp_name === "material" ) {
                this.$emit("deleteMaterial", tag)
            } else if ( this.comp_name === "custom_label" ) {
                this.$emit("delete_custom_label", tag)
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.main {
    // width: 400px;
    margin-top: 18px;
    .span-arrow-left, .span-arrow-right {
        display: inline-block;
        width: 20px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-radius: 3px;
        background-color: #B4BBCD;
        cursor: pointer;
        i {
            color: #FFFFFF;
        }
        &:hover {
            background-color: #a3a3a5;
        }
    }
    .span-arrow-left {
        margin-right: 10px;
    }
    .span-arrow-right {
        margin-left: 10px;
    }
    .no-allowed {
        cursor: not-allowed;
        // pointer-events: none;
    }
    .show_area {
        // border: 1px solid red;
        vertical-align: middle;
        height: 32px;
        // margin-top: -3px;
        display: inline-block;
        overflow: hidden;
        position: relative;
        .area {
            position: absolute;
            top: 0px;
            left: 0px;
            white-space: nowrap;
            span {
                margin: 0px 5px;
                // max-width: 150px;
                &:first-child {
                    margin-left: 0px;
                }
                &:last-child {
                    margin-right: 0px;
                }
            }
            
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/views/course/components/v_labels.vue